import { render, staticRenderFns } from "./CordatusServices.vue?vue&type=template&id=6519d2e4&scoped=true"
import script from "./CordatusServices.vue?vue&type=script&lang=js"
export * from "./CordatusServices.vue?vue&type=script&lang=js"
import style0 from "./CordatusServices.vue?vue&type=style&index=0&id=6519d2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6519d2e4",
  null
  
)

export default component.exports